import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";

const TermsConditionsPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div
      className="min-vh-100 d-flex flex-column justify-content-center"
      style={{
        background: "linear-gradient(to bottom right, #f5f9f6, #e0f2e9)",
        padding: "60px 15px",
      }}
    >
      <div className="container">
        <div
          className="card shadow-lg border-0 rounded-4"
          data-aos="fade-up"
          style={{ background: "#ffffffee", backdropFilter: "blur(5px)" }}
        >
          <div className="card-body p-5">
            <h1
              className="text-center mb-4 fw-bold"
              style={{ color: "#2e7d32" }}
              data-aos="zoom-in"
            >
              Terms & Conditions
            </h1>
            <p className="text-muted text-center mb-5" data-aos="fade-up">
              These terms govern your use of our website and services at{" "}
              <strong>RoupanNaturals</strong> , Under the proprietorship of Navdeep Kamal.
            </p>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">1. Acceptance</h4>
              <p>
                By accessing our website, you agree to abide by these Terms &
                Conditions. If you disagree, please do not use our services.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-left">
              <h4 className="fw-bold text-success">2. Products & Services</h4>
              <p>
                All descriptions and pricing are subject to change. We reserve
                the right to discontinue products or services at any time.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">3. Payments</h4>
              <p>
                All transactions are processed securely. By placing an order,
                you agree to provide accurate billing and shipping details.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-left">
              <h4 className="fw-bold text-success">4. Limitation of Liability</h4>
              <p>
                RoupanNaturals shall not be liable for any indirect or
                consequential damages arising from the use of our website or
                products.
              </p>
            </div>

            <div className="mb-4" data-aos="fade-right">
              <h4 className="fw-bold text-success">5. Governing Law</h4>
              <p>
                These Terms are governed by the laws of India. Any disputes will
                be handled by the competent courts in Delhi NCR, India.
              </p>
            </div>

            <div className="text-center mt-5">
              <button
                className="btn btn-success px-4 py-2 rounded-pill shadow-sm"
                onClick={() => window.history.back()}
                data-aos="zoom-in"
              >
                ← Back to Shop
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
